import React from 'react';

/**
 * Tiny SVG price sparkline — no axes, no labels.
 * points: number[] | { close?: number; price?: number }[]
 */
export default function SparklineChart({ points = [], color = '#22c55e', width = 80, height = 28 }) {
  const values = (points || []).map(p =>
    typeof p === 'number' ? p : (p.close ?? p.price ?? p.Close ?? 0)
  ).filter(v => typeof v === 'number' && !isNaN(v) && v > 0);

  if (values.length < 2) return <div style={{ width, height }} />;

  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const pad = 2;

  const xs = values.map((_, i) => pad + (i / (values.length - 1)) * (width - pad * 2));
  const ys = values.map(v => pad + (1 - (v - min) / range) * (height - pad * 2));
  const d  = xs.map((x, i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${ys[i].toFixed(1)}`).join(' ');

  return (
    <svg width={width} height={height} style={{ display: 'block', overflow: 'visible', flexShrink: 0 }}>
      <path d={d} fill="none" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
